import { render, staticRenderFns } from "./randomAvatar.vue?vue&type=template&id=27f7682d&scoped=true"
import script from "./randomAvatar.vue?vue&type=script&lang=js"
export * from "./randomAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7682d",
  null
  
)

export default component.exports